<script setup lang="ts">

import TextInput from "./TextInput.vue";
import {IconSearch} from "@iconify-prerendered/vue-carbon"
</script>

<template>
  <TextInput
      name="test"
      :full="true"
      :icon-prepend="IconSearch"
  ></TextInput>
</template>

<style scoped lang="scss">

</style>